import { useSessionStorage } from '@vueuse/core'

import { IFeedbackForm } from '~/types/feedback.type'

export const INITIAL_FEEDBACK_FORM: IFeedbackForm = {
  type: null,
  comment: '',
  url: '',
}

export const FEEDBACK_STORAGE = useSessionStorage('feedback', INITIAL_FEEDBACK_FORM)
